import React from "react";
import { Mic2 } from "lucide-react";
import { UserAvatar } from "../common/UserAvatar";
import type { QueueSong } from "../../types";

interface SingerCueBannerProps {
  currentSong: QueueSong | null;
  nextSong: QueueSong | null;
}

export const SingerCueBanner: React.FC<SingerCueBannerProps> = ({
  currentSong,
  nextSong,
}) => {
  if (!currentSong) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 w-full animate-fade-in">
      {/* Currently Singing */}
      <div className="bg-card/90 border border-primary/40 p-4 rounded-2xl flex items-center gap-3.5 shadow-lg">
        <div className="relative shrink-0">
          <UserAvatar
            photoURL={currentSong.addedByUserPhoto}
            name={currentSong.addedByUserName}
            uid={currentSong.addedByUserId}
            size="lg"
          />
          <div className="w-5 h-5 rounded-full bg-primary text-white flex items-center justify-center absolute -bottom-1 -right-1 shadow-sm">
            <Mic2 className="w-3 h-3" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <span className="text-[10px] font-bold uppercase tracking-wider text-primary">
            Now Singing
          </span>
          <h4 className="text-sm font-bold text-text-main truncate">
            {currentSong.title}
          </h4>
          <p className="text-xs text-text-muted truncate">
            Singer: <span className="font-semibold text-text-main">{currentSong.addedByUserName}</span>
          </p>
        </div>
      </div>

      {/* On Deck / Up Next */}
      {nextSong ? (
        <div className="bg-card/70 border border-border p-4 rounded-2xl flex items-center gap-3.5 shadow-md">
          <div className="relative shrink-0">
            <UserAvatar
              photoURL={nextSong.addedByUserPhoto}
              name={nextSong.addedByUserName}
              uid={nextSong.addedByUserId}
              size="lg"
            />
            <div className="w-5 h-5 rounded-full bg-accent text-background font-mono font-bold text-[10px] flex items-center justify-center absolute -bottom-1 -right-1 shadow-sm">
              #2
            </div>
          </div>
          <div className="min-w-0 flex-1">
            <span className="text-[10px] font-bold uppercase tracking-wider text-accent">
              On Deck (Get Ready!)
            </span>
            <h4 className="text-sm font-bold text-text-main truncate">
              {nextSong.title}
            </h4>
            <p className="text-xs text-text-muted truncate">
              Singer: <span className="font-semibold text-text-main">{nextSong.addedByUserName}</span>
            </p>
          </div>
        </div>
      ) : (
        <div className="bg-card/40 border border-dashed border-border/60 p-4 rounded-2xl flex items-center justify-center text-xs text-text-muted">
          No other songs in queue. Scan QR code to add!
        </div>
      )}
    </div>
  );
};
